import { PixTable, PixTableColumn } from '@1024pix/nebulix-ember';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';

const getTableName = (index, name) => `${index} - ${name}`;

export default class TargetProfileContent extends Component {
  @service intl;

  get targetProfileCompetences() {
    return this.args.currentCourse.frameworks
      .flatMap((framework) => framework.hasMany('areas').value())
      .flatMap((area) => area.hasMany('competences').value())
      .sort((a, b) => a.index - b.index)
      .map((competence) => {
        return {
          name: competence.name,
          index: competence.index,
          tubes: competence.sortedThematics.flatMap((thematic) => thematic.sortedTubes),
        };
      });
  }

  getCompetenceIndexLabel = (index) => {
    return `${this.intl.t('pages.catalogue.modal.target-profile-content.competence')} ${index}`;
  };

  <template>
    <div class="target-profile-content">
      {{#each this.targetProfileCompetences as |competence|}}
        <div class="target-profile-competence">
          <div class="target-profile-competence__title">
            <p>{{this.getCompetenceIndexLabel competence.index}}</p>
            <h2>{{competence.name}}</h2>
          </div>
          <PixTable
            @condensed={{true}}
            @variant="orga"
            @caption={{getTableName competence.index competence.name}}
            @data={{competence.tubes}}
          >
            <:columns as |tube context|>
              <PixTableColumn @context={{context}} class="target-profile-competence__description__column">
                <:header>
                  {{t "pages.catalogue.modal.tube-name-and-description"}}
                </:header>
                <:cell>
                  <span class="target-profile-competence__description__title">
                    {{tube.practicalTitle}}
                  </span>
                  <span class="target-profile-competence__description__text">
                    {{tube.practicalDescription}}
                  </span>
                </:cell>
              </PixTableColumn>
              <PixTableColumn @context={{context}} class="target-profile-competence__level__column">
                <:header>
                  {{t "pages.catalogue.modal.max-level"}}
                </:header>
                <:cell>
                  <span class="target-profile-competence__level__data">
                    {{#if tube.maxLevel}}
                      {{tube.maxLevel}}
                    {{else}}
                      {{t "pages.catalogue.modal.tube-unavailable"}}
                    {{/if}}
                  </span>
                </:cell>
              </PixTableColumn>
            </:columns>
          </PixTable>
        </div>
      {{/each}}
    </div>
  </template>
}
